// extracted by mini-css-extract-plugin
export default {"mail-to-link":"api-access_mail-to-link__RopvH","span-api-key-name":"api-access_span-api-key-name__FNNuW"};